const state = {
  total: 0,
};

export default state;
